export const dateFixer = (date: Date) => {
    return new Date( date.getTime() + Math.abs(date.getTimezoneOffset() * 60000));
};
